import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  sagaGetSucursales,
  sagaBorrarSucursal,
  sagaActivarSucursal,
} from "../../reducers/sucursalesReducer/actions";
import { sucursalesSelector } from "../../selectors/sucursalesSelector";
import SucursalesListado from "../../components/Sucursales";

const SucursalesContainer = ({
  history,
  sucursales,
  sagaGetSucursales,
  sagaBorrarSucursal,
  sagaActivarSucursal,
}) => {
  const [openModalConfirm, setOpenModalConfirm] = React.useState(false);
  const [botonOk, setBotonOk] = React.useState("");
  const [mensajeConfirmacion, setMensajeConfirmacion] = React.useState("");
  const [activo, setActivo] = React.useState("");
  const [idSucursal, setIdSucursal] = React.useState("");

  React.useEffect(() => {
    const payload = {
      idInstalacion: 3,
    };
    sagaGetSucursales(payload);
  }, [sagaGetSucursales]);

  const handleOnSearch = (nombre) => {
    const payload = {
      idInstalacion: 3,
      nombre: nombre,
    };
    sagaGetSucursales(payload);
  };

  const setHandleOkActivar = () => {
    if (activo) {
      sagaActivarSucursal(idSucursal);
    } else {
      sagaBorrarSucursal(idSucursal);
    }
    window.setTimeout(() => {
      const payload = {
        idInstalacion: 3,
      };
      sagaGetSucursales(payload);
    }, 700);
  };

  return (
    <SucursalesListado
      sucursales={sucursales}
      setHandleOkActivar={setHandleOkActivar}
      mapToItem={(x) => ({
        sucursal: x,
        cantIconos: 1,
        imagen: require("../../images/tienda.png"),
        onClick: () => {
          history.push("/Sucursales/Edit/" + x.idSucursal);
        },
        opciones: [
          x.activo
            ? {
                nombre: "Desactivar",
                handler: () => {
                  setOpenModalConfirm(true);
                  setBotonOk("Desactivar");
                  setMensajeConfirmacion(`Está por desactivar la sucursal ${x.nombre}`);
                  setActivo(false);
                  setIdSucursal(x.idSucursal);
                },
              }
            : undefined,
          !x.activo
            ? {
                nombre: "Activar",
                handler: () => {
                  setOpenModalConfirm(true);
                  setBotonOk("Activar");
                  setMensajeConfirmacion(`Está por activar la sucursal ${x.nombre}`);
                  setActivo(true);
                  setIdSucursal(x.idSucursal);
                },
              }
            : undefined,
        ],
      })}
      openModalConfirm={openModalConfirm}
      handleOnCloseConfirmacion={() => setOpenModalConfirm(false)}
      botonOk={botonOk}
      mensajeConfirmacion={mensajeConfirmacion}
      handleOnSearch={(nombre) => handleOnSearch(nombre)}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sagaGetSucursales,
      sagaBorrarSucursal,
      sagaActivarSucursal,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    sucursales: sucursalesSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SucursalesContainer);
